module.exports = __webpack_public_path__ + "assets/img/23_124.9dd4f51e.jpg";